<div class="p-grid p-fluid">
  <div class="col-md-12 col-sm-12 col-xs-12">
    <div [innerHTML]="body" class="message-body">

    </div>
  </div>
  <div class="col-md-12 col-sm-12 col-xs-12 margin-top-15 text-align-right p-mb-2">
    <p-button (click)="goToComm()" [className]="'inline-button'" class="p-button-info p-mr-2"
              label="Go To Grievance" pTooltip="Go To Grievance" tooltipPosition="bottom"></p-button>
    <p-button (click)="cancel()" [className]="'inline-button'" class="p-button-info p-mr-2" label="Cancel" pTooltip="Cancel"
              tooltipPosition="bottom"></p-button>


  </div>
</div>
